import classNames from 'classnames';
import React from 'react';
import TextWithIcon from '../components/TextWithIcon';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import * as styles from './PostTitleWithIcons.module.scss';
import VerifiedIcon from './VerifiedIcon';

const POST_FRAGMENT = gql(`
  fragment PostTitleWithIcons_post on RootPostFields {
    id
    title
    ... on SlimPostFields {
      verifiedAt
    }
  }
`);

type PostTitleWithIconsProps = {
  iconSize?: 'small' | 'regular';
  post?: DocumentType<typeof POST_FRAGMENT>;
} & (
  | {
      truncate: true;
      title?: string;
    }
  | {
      truncate?: never;
      title?: React.ReactNode;
    }
);

const PostTitleWithIcons = ({
  iconSize = 'regular',
  post,
  title,
  truncate,
}: PostTitleWithIconsProps) => {
  const icon = post && (
    <>
      {'verifiedAt' in post && !!post.verifiedAt && (
        <span className={classNames(styles.icon, styles[iconSize])}>
          <VerifiedIcon inline size={iconSize} />
        </span>
      )}
    </>
  );

  const postTitle = post?.title || '';

  return (
    <TextWithIcon
      icon={icon}
      {...(truncate
        ? { text: title || postTitle, truncate: true }
        : { text: title || postTitle })}
    />
  );
};

export default PostTitleWithIcons;
